export function parseSweep(str) {
    const data = str.split(":");
    if (data.length !== 2) {
        throw new Error("invalid sweep data");
    }

    const [sweepId, rotation] = data;

    const rotationData = rotation.split(",");
    if (rotationData.length !== 2) {
        throw new Error("invalid rotation data");
    }

    const [rotX, rotY] = rotationData.map(r =>  {
        const num = parseFloat(r);
        if (isNaN(num)) {
            throw new Error("invalid rotation: " + r);
        }
        return num;
    });

    return [sweepId, rotX, rotY];
}

export function getSweepParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const sweepStr = urlParams.get("sweep");
    if (!sweepStr) {
        return null;
    }

    return parseSweep(sweepStr);
}
